/* V-NEXUS header nav
   1. Fit: the menu capsule always fits its space on one line. If the items are wider than
      the room the header gives them, the whole list is scaled down (CSS zoom via --vn-nav-fit),
      so nothing is ever cut off — desktop, tablet or phone.
   2. Pill: a red pill slides behind the hovered / current menu item.
   Progressive enhancement: without JS the current item is still highlighted by CSS. */
(() => {
  const MIN_FIT = 0.62;

  const init = (nav) => {
    const list = nav.querySelector('.list-menu--inline');
    if (!list || nav.dataset.vnNav) return;
    nav.dataset.vnNav = '1';

    const items = [...list.querySelectorAll(':scope > li > .header__menu-item, :scope > li > header-menu summary.header__menu-item, :scope > li details > summary.header__menu-item')];
    if (!items.length) return;

    const pill = document.createElement('span');
    pill.className = 'vn-nav-pill';
    pill.setAttribute('aria-hidden', 'true');
    nav.prepend(pill);
    nav.classList.add('has-pill');

    const current = items.find((el) => el.querySelector('.header__active-menu-item') || el.getAttribute('aria-current') === 'page');
    let target = null;

    const moveTo = (el) => {
      if (target) target.classList.remove('is-pill-target');
      target = el;
      if (!el) return pill.classList.remove('is-visible');
      const navBox = nav.getBoundingClientRect();
      const box = el.getBoundingClientRect();
      pill.style.setProperty('--x', box.left - navBox.left + nav.scrollLeft + 'px');
      pill.style.setProperty('--w', box.width + 'px');
      pill.classList.add('is-visible');
      el.classList.add('is-pill-target');
    };

    // Scale the list down just enough to fit the room the header gives the nav.
    const fit = () => {
      nav.style.setProperty('--vn-nav-fit', '1');
      const styles = getComputedStyle(nav);
      const room = nav.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
      const need = list.scrollWidth;
      const scale = need > room ? Math.max(MIN_FIT, Math.floor((room / need) * 1000) / 1000) : 1;
      nav.style.setProperty('--vn-nav-fit', String(scale));
      moveTo(target || current);
    };

    items.forEach((el) => {
      el.addEventListener('pointerenter', () => moveTo(el));
      el.addEventListener('focus', () => moveTo(el));
    });
    nav.addEventListener('pointerleave', () => moveTo(current));
    nav.addEventListener('focusout', (event) => {
      if (!nav.contains(event.relatedTarget)) moveTo(current);
    });

    fit();
    requestAnimationFrame(() => nav.classList.add('is-ready'));

    // Re-fit when the header's space changes (resize, rotate) and once web fonts are in.
    let frame = 0;
    const refit = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(fit);
    };
    new ResizeObserver(refit).observe(nav.parentElement);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
  };

  const run = () => document.querySelectorAll('.header__inline-menu').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  document.addEventListener('shopify:section:load', run);
})();
